import React, { Component } from "react";
import { Link, NavLink, withRouter } from "react-router-dom";
import logo from "../../img/ntblogo.svg";
import TextField from "./form/TextField";
import NumberField from "./form/NumberField";
import CheckboxField from "./form/CheckboxField";
import SelectField from "./form/SelectField";
import PropTypes from "prop-types";
import moment from "moment";
import classNames from "classnames";
import queryString from "query-string";
//import { addDays } from 'date-fns';

import DatePicker, { registerLocale } from "react-datepicker";
import nb from "date-fns/locale/nb";
import db from "../../api/db";
import user from "../../api/user";
registerLocale("nb", nb);
moment.locale("nb");

class Headerbar extends Component {
  static propTypes = {
    searchParams: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      age: "",
      postalcode: "",
      string: "",
      male: "",
      female: "",
      famous: false,
      sport: false,
      mention: false,
      glory: false,
      dead: 0,
      income_from: null,
      income_to: null,
      assets_from: null,
      assets_to: null,
      session_operation: "0",
      session_date: new Date(),
      location: this.props.location.pathname,
      textsearch: false,
      disabled: false,
      clientcodes: false,
      oslo95: false,
      client: "",
      clients: [],
      lists: {
        submitted: [],
        drafts: []
      },
      username: ""
    };

    this.handledateChange = this.handledateChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOperationChange = this.handleOperationChange.bind(this);
    this.handleClearText = this.handleClearText.bind(this);
  }

  componentWillReceiveProps(props) {
    let location = props.location.pathname;
    let disabled = props.Disabled;
    let session_operation = this.state.session_operation;

    if (
      this.state.session_date !== props.Params.session_date &&
      props.Params.session_date
    ) {
      this.handledateChange(this.props.Params.session_date);
    }
    if (
      this.state.session_operation !== props.Params.session_operation &&
      props.Params.session_operation
    ) {
      session_operation = props.Params.session_operation;
      this.getLists(session_operation);
    }

    const loca_array = location.split("/");
    loca_array.shift();

    if (loca_array[0] !== "search") {
      session_operation = "0";
    }

    let states = {
      location: location,
      disabled: disabled,
      session_operation: session_operation
    };

    const searchQuery = queryString.parse(props.location.search);
    states = Object.assign(states, searchQuery);
    this.setState(states);
  }

  componentDidMount() {
    const location = this.state.location.split("/");
    location.shift();
    let params = this.state;

    if (location[0] === "search") {
      if (location[1] && location[2] && moment(location[2]).isValid()) {
        params.session_operation = location[1];
        params.session_date = moment(location[2]).toDate();
      } else if (location[1]) {
        params.session_operation = location[1];
      }
    }

    const searchQuery = queryString.parse(this.props.location.search);
    params = Object.assign(params, searchQuery);

    this.getUser();
    this.getLists();
    this.setState(searchQuery, () => {
      this.props.searchParams(params);
    });
  }

  getUser() {
    user
      .get()
      .then(user => {
        this.setState({
          username: `${user.firstname} ${user.lastname}`
        });
      })
      .catch(err => {
        window.location.href = `${window.location.origin}/login/`;
        console.log(err);
      });
  }

  handleChange(event) {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;

    let newState = {};

    if (name === "male" && value) {
      newState["female"] = false;
    }

    if (name === "female" && value) {
      newState["male"] = false;
    }

    if (name === "string") {
      if (value.length > 0) {
        newState["textsearch"] = true;
      } else {
        newState["textsearch"] = false;
      }
    }

    if (name === "session_operation" && value !== "jubilee") {
      newState["client"] = "";
    }

    if (name === "session_operation") {
      this.getLists(value);
    }

    if (target.type === "number") {
      newState[name] = parseInt(value);
    } else {
      newState[name] = value;
    }

    this.setState(newState, () => {
      if (
        name !== "string" &&
        ((name === "postalcode" &&
          (value.length === 4 || value.length === 0)) ||
          target.type === "checkbox" ||
          (target.type === "select-one" && value !== "jubilee") ||
          (name === "age" && (value.length >= 2 || value.length === 0)))
        //||
        //(target.type === 'number' && value > 100)
      ) {
        this.props.history.push({
          search: this.createQueryString()
        });
        this.props.searchParams(this.state);
      }
    });
  }

  createQueryString(params = this.state) {
    const query = {};
    Object.keys(params).map(function (key) {
      if (
        key !== "username" &&
        key !== "lists" &&
        key !== "session_operation" &&
        key !== "location" &&
        key !== "session_date" &&
        params[key]
      ) {
        return (query[key] = params[key]);
      }
      return null;
    });
    return queryString.stringify(query);
  }

  handledateChange(date) {
    this.setState(
      {
        session_date: date
      },
      () => {
        if (this.state.session_operation.length > 1) {
          this.props.searchParams(this.state);
          this.getLists();
          this.props.history.push({
            pathname: `/search/${this.state.session_operation}/${moment(
              this.state.session_date
            ).format("YYYY-MM-DD")}`,
            search: this.createQueryString(),
            state: { params: this.state }
          });
        }
      }
    );
  }

  handleOperationChange(event) {
    const target = event.target;
    const value = target.value !== "0" ? target.value : "0";

    let date = "";

    this.setState(
      {
        session_operation: value
      },
      () => {
        if (value !== "0") {
          this.props.searchParams(this.state);
          if (value !== "edit") {
            date = moment(this.state.session_date).format("YYYY-MM-DD");
            this.getLists(value);
          }
          this.props.history.push({
            pathname: `/search/${this.state.session_operation}/${date}`,
            search: this.createQueryString(),
            state: { params: this.state }
          });
        }
      }
    );
  }

  handleSubmit(event) {
    event.preventDefault();
    this.props.history.push({
      search: this.createQueryString()
    });
    this.props.searchParams(this.state);

    if (!this.onSearchPage()) {
      this.props.history.push("/search");
    }
  }

  handleClearText() {
    this.setState(
      {
        string: "",
        textsearch: false
      },
      () => {
        this.props.history.push({
          search: this.createQueryString()
        });
        this.props.searchParams(this.state);
      }
    );
  }

  getLists(operation = this.state.session_operation) {
    if (operation !== "edit") {
      db.query("list", {
        type: operation,
        date: {
          from: `${moment().subtract(1, "days").format("YYYY-MM-DD")} 00:00:00`,
          to: `${moment().add(100, "days").format("YYYY-MM-DD")} 00:00:00`
        },
        pagination: {
          size: 100
        }
      })
        .then(response => {
          let submitted = [];
          let drafts = [];
          if (response.data.hits) {
            for (var i = response.data.hits.length - 1; i >= 0; i--) {
              var date = moment(response.data.hits[i].date).toDate();
              if (
                moment(response.data.hits[i].submitted) > moment("1990-01-01")
              ) {
                submitted.push(date);
              } else if (response.data.hits[i].persons.length) {
                drafts.push(date);
              }
            }
            this.setState({
              lists: {
                submitted: submitted,
                drafts: drafts
              }
            });
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }

  onSearchPage() {
    const location = this.state.location.split("/");
    location.shift();
    if (location[0] === "search") {
      return true;
    }
    return false;
  }

  getBoolean(value) {
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  }

  render() {
    const highlightDates = [
      { "marked green": this.state.lists.submitted },
      { "marked yellow": this.state.lists.drafts }
    ];

    return (
      <React.Fragment>
        <div className="top-bar">
          <div className="grid-x">
            <div className="medium-9 left cell">
              <div className="left">
                <Link to="/">
                  <img className="logo" alt="logo" src={logo} />
                </Link>
                <div className="grid-x grid-padding-x align-middle">
                  <div className="medium-4 cell">
                    <SelectField
                      name="session_operation"
                      value={
                        this.state.session_operation
                          ? this.state.session_operation
                          : "0"
                      }
                      onChange={this.handleOperationChange}
                      options={[
                        { value: "0", label: "- Velg Operasjon -" },
                        { value: "mention", label: "Omtale" },
                        { value: "fleng", label: "Fødselsdager" },
                        { value: "edit", label: "Rediger personer" }
                      ]}
                    />
                  </div>
                  {this.state.session_operation === "jubilee" ? (
                    <div className="medium-4 cell">
                      <SelectField
                        name="client"
                        value={this.state.client}
                        onChange={this.handleChange}
                        options={this.state.clients}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {this.state.session_operation !== "edit" &&
                  this.state.session_operation.length > 1 ? (
                    <div className="medium-4 cell">
                      <DatePicker
                        selected={this.state.session_date}
                        onChange={this.handledateChange}
                        onSelect={this.handledateChange}
                        dateFormat="dd.MMMM yyyy"
                        locale="nb"
                        placeholderText="Velg dag"
                        highlightDates={highlightDates}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {this.onSearchPage() ? (
                <form
                  className="search js-search-form"
                  onSubmit={this.handleSubmit}
                >
                  <div className="btn js-toggle-search">
                    <div className="icon"></div>
                  </div>
                  <label>
                    <input
                      className="mainstring"
                      placeholder="Fritekst søk"
                      name="string"
                      type="text"
                      value={this.state.string}
                      onChange={this.handleChange}
                    />
                  </label>
                  <input className="hide" type="submit" value="Submit" />
                  <span
                    onClick={this.handleClearText}
                    className={classNames("remove", {
                      show: this.state.string
                    })}
                  >
                    Fjern
                  </span>
                </form>
              ) : (
                ""
              )}
            </div>
            <div className="medium-3 top-bar-right cell">
              <div className="right">
                <div>
                  <NavLink to={"/client/"} className="hollow button secondary">
                    Kundekort
                  </NavLink>
                  <NavLink to={"/person"} className="hollow button secondary">
                    Andre Personer
                  </NavLink>
                </div>

                <a className="user link" href="/logout">
                  Logg ut
                </a>
              </div>
            </div>
          </div>
        </div>
        {this.onSearchPage() ? (
          <div className="top-filters">
            <form className="grid-x align-middle" onSubmit={this.handleSubmit}>
              <TextField
                className="inline-input"
                name="age"
                value={this.state.age}
                label="Alder"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />

              <NumberField
                className="inline-input"
                name="income_from"
                value={this.state.income_from}
                label="Inntekt"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />
              <NumberField
                className="inline-input"
                name="income_to"
                value={this.state.income_to}
                label="-"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />

              <NumberField
                className="inline-input"
                name="assets_from"
                value={this.state.assets_from}
                label="Formue"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />
              <NumberField
                className="inline-input"
                name="assets_to"
                value={this.state.assets_to}
                label="-"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />

              <CheckboxField
                name="male"
                value={this.getBoolean(this.state.male)}
                label="Mann"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />
              <CheckboxField
                name="female"
                value={this.getBoolean(this.state.female)}
                label="Kvinne"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />
              <CheckboxField
                name="famous"
                value={this.getBoolean(this.state.famous)}
                label="Kjent"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />
              <CheckboxField
                name="sport"
                value={this.getBoolean(this.state.sport)}
                label="Idrettsprofil"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />
              <CheckboxField
                name="dead"
                value={this.getBoolean(this.state.dead)}
                label="Død"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />
              <CheckboxField
                name="mention"
                value={this.getBoolean(this.state.mention)}
                label="Viktig"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />
              <CheckboxField
                name="glory"
                value={this.getBoolean(this.state.glory)}
                label="Æresgalleri"
                onChange={
                  this.handleChange
                } /*disabled={this.state.textsearch}*/
              />

              <input
                className="button primary hide"
                type="submit"
                value="Submit"
              />
            </form>
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  }
}

/*
 * Disabled fields
 *
 <div className="user text">{this.state.username}</div>
<CheckboxField name="clientcodes" value={this.getBoolean(this.state.clientcodes)} label="Kunders postnummer" onChange={this.handleChange} disabled={this.state.textsearch} />
<CheckboxField name="oslo95" value={this.getBoolean(this.state.oslo95)} label="Oslo + 95" onChange={this.handleChange} disabled={this.state.textsearch} />
*/

export default withRouter(Headerbar);
